import { useChatUnread } from '@src/hooks/useChat';
import { isChatMock } from '@src/services/chat';
import profileAtom from '@src/recoils/atom/profile';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

/**
 * 헤더의 쪽지함 진입 버튼 + 안읽음 배지.
 * 앱의 채팅 탭에 대응하는 웹 진입점. 로그인 상태에서만 노출된다.
 * 안읽음 수는 GET /api/v1/chat/unread-count 를 주기적으로 폴링.
 */
const ChatNavButton = () => {
  const router = useRouter();
  const profile = useRecoilValue(profileAtom);
  const loggedIn = profile.isLoggedIn || isChatMock();
  const { unread, reload } = useChatUnread(loggedIn);

  // 채팅방을 열면 읽음 처리되므로 경로가 바뀔 때 배지를 바로 다시 계산한다.
  useEffect(() => {
    if (!loggedIn) return;
    const t = setTimeout(reload, 1200);
    return () => clearTimeout(t);
  }, [router.asPath, loggedIn, reload]);

  if (!loggedIn) return null;

  return (
    <Button onClick={() => router.push('/chat')} aria-label="쪽지함">
      <Icon />
      {unread > 0 && <Badge>{unread > 99 ? '99+' : unread}</Badge>}
    </Button>
  );
};

const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.commonColor.black};

  &:hover {
    color: ${({ theme }) => theme.commonColor.pink004};
  }
`;

const Icon = styled(IoChatbubbleEllipsesOutline)`
  width: 24px;
  height: 24px;
`;

const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.commonColor.pink004};
  color: ${({ theme }) => theme.commonColor.white};
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
`;

export default ChatNavButton;
